import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosNoAuth } from "../config/axiosInstance";

export const reportVideoQuality = createAsyncThunk(
    'reportVideo/reportVideoQuality',
    async ({ user_id, course_name, video_url, reason, comments, video_start, video_end, lesson_id }) => {      
        try {
            const response = await axiosNoAuth.post('https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/report_video', { user_id: user_id, course_name: course_name, video_url: video_url, reason: reason, comments: comments, video_start: video_start, video_end: video_end, lesson_id: lesson_id });
            return response.data;
        } catch (err) {
            console.log(err);
        }
    }
);

const initialState = {}
const reportVideoSlice = createSlice({
    name: 'reportVideo',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(reportVideoQuality.fulfilled, (state, action) => {
            return action.payload
        })
    },
});

export const selectReportVideoStatus = (state) => state.reportVideo;
export default reportVideoSlice.reducer;